import { render, staticRenderFns } from "./ParcelsList.vue?vue&type=template&id=16981497&"
import script from "./ParcelsList.vue?vue&type=script&lang=js&"
export * from "./ParcelsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports